export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}company/integration-log`;

    return $resource(url, null, {});
};



// WEBPACK FOOTER //
// ./src/app/resources/IntegrationLog/index.js